export const DeliveryType = {
  RUSSIAN: 'russian',
  SDEK: 'sdek',
  SNG: 'SNG'
};
